module.exports = __webpack_public_path__ + "img/f55eefb.jpg";